import { MessageMetadata } from '@aionzdev/design-system';

export enum SupportedFileTypes {
  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PDF = 'pdf',
  XLSX = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS = 'vnd.ms-excel',
}

export enum TypesMessage {
  TEXT = 'text',
  DOC = 'doc',
  XLSX = 'xlsx',
  IMAGE = 'image',
  SYSTEM = 'system',
  SYSTEM_DATE = 'system_date',
  AUDIO = 'audio',
}

export enum MessageStatus {
  WAIT = 'wait',
  READ = 'read',
  SENT = 'sent',
}

export type ChatContext = {
  chatHash?: string;
  nextRoute?: string;
  image?: string;
  title?: string;
  context1?: string;
  context2?: string;
  context3?: string;
  context4?: string;
  context5?: string;
  updatedAt?: Date;
  createdAt?: Date;
};

export type Chat = {
  chatHash: string;
  title: string;
  messages?: Message[];
  users: number[];
  image?: string;
  context?: ChatContext;
  createdBy?: number;
  lastMessage?: string;
  lastMessageType?: string;
  lastMessageUser?: number;
  messageCount?: number;
  isGroup?: boolean;
  isArchived?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export interface ChatWithUnreadMessages extends Chat {
  numberUnreadMessages: number;
}

export type Message = {
  /** Identificador persistido, usado para localizar resultados de busca no histórico. */
  id?: string;
  chatHash: string;
  from: number;
  to: number[];
  type: TypesMessage;
  content: string | ArrayBuffer;
  file?: File;
  fileName?: string;
  fileSize?: string;
  status: MessageStatus;
  hasError?: boolean;
  time?: Date;
  idTemp?: string;
  /** Opções clicáveis enviadas pelo agente de IA (geradas só pelo servidor). */
  metadata?: MessageMetadata | null;
  /** Resposta do agente ainda sendo gerada (balão provisório, não persistido). */
  streaming?: boolean;
  /** Progresso exibido enquanto o balão em streaming não tem texto. */
  streamingStatus?: string;
  /** `seq` do último `aiStreamReset`: deltas com seq menor chegaram atrasados. */
  streamResetSeq?: number;
};

export interface MessageWebSocket extends Message {
  title?: string;
  image?: string;
  chatContext?: ChatContext;
  isGroup?: boolean;
  data?: Record<string, unknown>;
}
